import styled, { keyframes } from 'styled-components';
import { FlexBox } from '@/components/atom/FlexBox';
import { Theme } from '@/styles/theme';
import { PaddingProps } from '@/types/ui';

const borderGraident = keyframes`
  0% {
    background-position: 0% 50%;
  }

  50% {
      background-position: 100% 50%;
  }

  100% {
      background-position: 0% 50%;
  }
`;

export const GlowPanel = styled(FlexBox)<{
  $padding?: PaddingProps;
  $rounded?: keyof Theme['rounded'];
}>`
  padding: ${(p) =>
    typeof p.$padding === 'object'
      ? `${p.theme.size[p.$padding.y]} ${p.theme.size[p.$padding.x]}`
      : p.$padding
        ? p.theme.size[p.$padding]
        : 0};
  ${(p) => p.theme.rounded[p.$rounded ?? 'zero']};
  background-image: linear-gradient(-45deg, #2153cc, #d9e6ff);
  border-radius: 1000px;
  -webkit-border-radius: 1000px;
  -moz-border-radius: 1000px;
  -ms-border-radius: 1000px;
  background-size: 400% 400%;
  animation: ${borderGraident} 3s linear infinite;
`;
